import React from 'react';

import { Stack } from '@atlaskit/primitives';

// TODO: display work items in CBT-4867 (https://hello.jira.atlassian.cloud/browse/CBT-4867)
// TODO: implement analytics in CBT-4868 (https://hello.jira.atlassian.cloud/browse/CBT-4868)
export const JiraWorkItemsPanelBody = () => (
	<>
		<Stack testId="jira-work-items-panel-body">
			{/* display work items here */}
			Jira work items to be listed here
		</Stack>
	</>
);
